module.exports = __webpack_public_path__ + "static/media/ic-barcode.2f7594d0.svg";